import FollowOrganizationLink from './FollowOrganizationLink';
export default FollowOrganizationLink;